export const coreUI = {
  en: {
    retry: 'Retry',
    ok: 'OK',
    none: 'None',
    previous: 'Previous',
    top: 'Top',
    noQuestionsAvailable: 'No questions available for this selection.',
    // Authentication
    signIn: 'Sign In',
    signUp: 'Sign Up',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    preferredLanguage: 'Preferred Language',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    welcomeBack: 'Welcome back! Sign in to continue your spiritual journey',
    joinKingdom: 'Join Kingdom Bible Quiz! Create your account to begin your journey',
    howShouldWeCallYou: 'How should we call you?',
    
    // Navigation
    back: 'Back',
    next: 'Next',
    continue: 'Continue',
    finish: 'Finish',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    save: 'Save',
    
    // Main Navigation
    solo_play: 'Solo Play',
    friends_family_play: 'Friends & Family',
    play: 'Play',
    together: 'Together',
    me: 'Me',
    live: 'Live',
    solo_testament_info: 'Study at your own pace with focused Bible learning!',
    multiplayer_testament_info: 'Challenge your friends and family with targeted Bible study!',
    challenge_testament_info: 'Create a personal challenge with focused Bible topics!',
    share: 'Share',
    community: 'Community',
    more: 'More',
    continue_journey: 'Continue Your Journey',
    explore: 'Explore',
    daily_challenge_label: 'Daily Challenge',
    start_todays_challenge: "Start Today's Challenge",
    resume_last_topic: 'Resume Last Topic',
    local_progress_title: 'Local Progress',
    local_progress_subtitle: 'This progress stays on this device until you sign in.',
    quizzes_completed_label: 'Quizzes Completed',
    recovery_welcome_back: 'Welcome Back',
    recovery_saved_progress_found: 'We found your saved progress from a previous session.',
    recovery_sign_in_restore: 'Sign in with {{provider}} to restore your progress.',
    recovery_sign_in_restore_cta: 'Sign in with {{provider}}',
    recovery_skip_restore: 'Keep Playing Without Restore',

    // Testament Screen
    header: 'Which part of the Bible?',
    old: 'Old Testament',
    old_desc: 'Books from Genesis to Malachi',
    new: 'New Testament', 
    new_desc: 'Books from Matthew to Revelation',
    books_of_the_bible: 'Books of the Bible',
    books_of_the_bible_desc: 'All books from Genesis to Revelation',
    general: 'General',
    general_description: 'Quiz on various Bible topics and themes',
    books_focus_description: 'Study specific books from the Bible',
    begin_journey: 'Begin Your Journey',
    choose_your_path: 'Choose Your Path',
    explore_gods_word: 'Explore God\'s Word',
    old_testament: 'Old Testament',
    new_testament: 'New Testament',
    hebrew_scriptures: 'The Hebrew Scriptures & Prophetic Books',
    christian_scriptures: 'The Gospel & Apostolic Letters',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: 'What would you like to be quizzed on?',
    category: 'Category',
    no_difficulties: 'No difficulties found.',
    select_your_challenge: 'Select Your Challenge',
    choose_difficulty_description: 'Choose the difficulty level that best matches your biblical knowledge',
    easy: 'Easy',
    easy_desc: 'Great for beginners',
    medium: 'Medium',
    medium_desc: 'For regular players', 
    hard: 'Hard',
    hard_desc: 'For experienced explorers',
    
    // Game Modes
    solo: 'Single Play',
    multiplayer: 'Multiplayer',
    
    // Common UI Elements
    loading: 'Loading...',
    loadingApp: 'Loading Kingdom Bible Quiz...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',
    player: 'Player',
    user: 'User',
    
    // Accessibility Labels
    backButton: 'Back',
    closeButton: 'Close', 
    userAvatar: 'User avatar',
    playerLabel: 'Player',
    
    // Invite Modal
    inviteFriends: 'Invite Friends',
    roomCode: 'Room Code',
    shareThisCode: 'Share this code with friends to join your game',
    shareVia: 'Share via:',
    inviteAppFriend: 'Invite App Friend',
    shareViaMessage: 'Share via Message',
    shareViaEmail: 'Share via Email',
    copied: 'Copied!',
    copy: 'Copy',
    inviteFriendPrompt: 'Invite Friend',
    enterFriendId: 'Enter your friend\'s user ID (for demo; integrate friend picker for production):',
    send: 'Send',
    inviteSuccess: 'Success',
    inviteSuccessMessage: 'Game invite sent to your friend!',
    inviteError: 'Error',
    inviteErrorMessage: 'Failed to send invite notification.',
    
    // Language Selection
    currentLanguage: 'Current language',
    tapToChangeLanguage: 'Tap to change language',
    
    // Achievement Badge
    earnedOn: 'Earned on',
    
    // Mastery Chart
    testamentMastery: 'Testament Mastery',
    bookMastery: 'Book Mastery', 
    categoryMastery: 'Category Mastery',
    noMasteryData: 'No mastery data available yet.',
    
    // Chat
    messageInputField: 'Message input field',
    pressEnterToSend: 'Press Enter to send message',
    
    // App Logo
    appLogo: 'Kingdom Bible Quiz App Logo',
    
    // Multiplayer Game
    winner: 'Winner',
    completed: 'Completed',
    didNotParticipate: 'Did Not Participate',
    leaderboard: 'Leaderboard',
    
    // Player Stats
    // player: 'Player', // Already defined at line 78
    correct: 'Correct',
    time: 'Time',
    score: 'Score',
    you: 'You',
    
    // Progress Chart  
    accuracy: 'Accuracy',
    progressOverTime: 'Progress Over Time',
    chartPlaceholder: 'Progress chart data will be displayed here',
    progressChartData: 'Progress chart data will be displayed here',
    
    // Common nested object for common.loading, common.retry, etc.
    common: {
      // loading: 'Loading', // Already defined at line 72
      retry: 'Retry',
    },
    
    // Quiz UI
    loading_quiz: 'Loading Quiz...',
    quiz_complete: 'Quiz Complete!',
    well_done: 'Well Done!',
    question_progress: 'Question {current} of {total}',
    seconds: 's',
    time_remaining: 'Time Remaining',
    explanation: 'Explanation',
    next_question: 'Next Question',
    
    // Accessibility
    select_book_hint: 'Tap to select this Bible book',
    no_testament_error: 'No testament selected. Please go back and choose Old or New Testament.',
    
    // Book Selection Screen
    old_testament_display: 'OLD TESTAMENT',
    new_testament_display: 'NEW TESTAMENT', 
    popular: 'Popular',
    chapters: 'chapters',
    scripture_study: 'Scripture Study',
    
    // Bible Book Themes
    creation_origins: 'Creation & Origins',
    freedom_law: 'Freedom & Law',
    holiness_worship: 'Holiness & Worship',
    journey_faith: 'Journey & Faith',
    covenant_law: 'Covenant & Law',
    conquest_victory: 'Conquest & Victory',
    leadership_cycles: 'Leadership & Cycles',
    love_loyalty: 'Love & Loyalty',
    worship_prayer: 'Worship & Prayer',
    wisdom_life: 'Wisdom & Life',
    king_kingdom: 'King & Kingdom',
    servant_action: 'Servant & Action',
    savior_compassion: 'Savior & Compassion',
    son_god_love: 'Son of God & Love',
    church_mission: 'Church & Mission',
    gospel_grace: 'Gospel & Grace',
    victory_glory: 'Victory & Glory',
  },
  
  fr: {
    retry: 'Réessayer',
    ok: 'OK',
    none: 'Aucune',
    previous: 'Précédent',
    top: 'Top',
    noQuestionsAvailable: 'Aucune question disponible pour cette sélection.',
    inviteFriendPrompt: 'Inviter un ami',
    enterFriendId: 'Saisissez l\'identifiant utilisateur de votre ami :',
    send: 'Envoyer',
    inviteSuccess: 'Succès',
    inviteSuccessMessage: 'Invitation à la partie envoyée à votre ami !',
    inviteError: 'Erreur',
    inviteErrorMessage: 'Échec de l\'envoi de la notification d\'invitation.',
    progressChartData: 'Les données du graphique de progression s\'afficheront ici',
    winner: 'Gagnant',
    completed: 'Terminé',
    didNotParticipate: 'N\'a pas participé',
    leaderboard: 'Classement',
    correct: 'Correct',
    time: 'Temps',
    you: 'Vous',
    accuracy: 'Précision',
    chartPlaceholder: 'Les données du graphique de progression s\'afficheront ici',
    currentLanguage: 'Langue actuelle',
    progressOverTime: 'Progression dans le temps',
    score: 'Score',
    tapToChangeLanguage: 'Touchez pour changer de langue',
    // Authentication
    signIn: 'Se Connecter',
    signUp: "S'inscrire",
    email: 'Email',
    password: 'Mot de Passe',
    name: 'Nom',
    preferredLanguage: 'Langue Préférée',
    createAccount: 'Créer un Compte',
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    dontHaveAccount: "Vous n'avez pas de compte?",
    welcomeBack: 'Bon retour! Connectez-vous pour continuer votre voyage spirituel',
    joinKingdom: 'Rejoignez Kingdom Bible Quiz! Créez votre compte pour commencer votre voyage',
    howShouldWeCallYou: 'Comment devons-nous vous appeler?',
    
    // Navigation
    back: 'Retour',
    next: 'Suivant',
    continue: 'Continuer',
    finish: 'Terminer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    save: 'Enregistrer',
    
    // Main Navigation
    solo_play: 'Jeu Solo',
    friends_family_play: 'Amis et Famille',
    play: 'Jouer',
    together: 'Ensemble',
    me: 'Moi',
    live: 'En Direct',
    solo_testament_info: 'Étudiez à votre rythme avec un apprentissage biblique ciblé !',
    multiplayer_testament_info: 'Défiez vos amis et votre famille avec une étude biblique ciblée !',
    challenge_testament_info: 'Créez un défi personnel avec des sujets bibliques ciblés !',
    share: 'Partager',
    community: 'Communauté',
    more: 'Plus',
    continue_journey: 'Continuez Votre Parcours',
    explore: 'Explorer',

    // Testament Screen
    header: 'Quelle partie de la Bible?',
    old: 'Ancien Testament',
    old_desc: 'Livres de la Genèse à Malachie',
    new: 'Nouveau Testament',
    new_desc: 'Livres de Matthieu à l\'Apocalypse',
    books_of_the_bible: 'Livres de la Bible',
    books_of_the_bible_desc: 'Tous les livres de la Genèse à l\'Apocalypse',
    general: 'Général',
    general_description: 'Quiz sur divers sujets et thèmes bibliques',
    books_focus_description: 'Étudiez des livres spécifiques de la Bible',
    begin_journey: 'Commencez votre voyage',
    choose_your_path: 'Choisissez votre chemin',
    explore_gods_word: 'Explorez la Parole de Dieu',
    daily_challenge_label: 'Défi quotidien',
    start_todays_challenge: 'Commencer le défi du jour',
    resume_last_topic: 'Reprendre le dernier thème',
    local_progress_title: 'Progression locale',
    local_progress_subtitle: 'Cette progression reste sur cet appareil jusqu\'à ce que vous vous connectiez.',
    quizzes_completed_label: 'Quiz terminés',
    recovery_welcome_back: 'Bon retour',
    recovery_saved_progress_found: 'Nous avons retrouvé votre progression d\'une session précédente.',
    recovery_sign_in_restore: 'Connectez-vous avec {{provider}} pour restaurer votre progression.',
    recovery_sign_in_restore_cta: 'Se connecter avec {{provider}}',
    recovery_skip_restore: 'Continuer sans restaurer',
    old_testament: 'Ancien Testament',
    new_testament: 'Nouveau Testament',
    hebrew_scriptures: 'Les Écritures hébraïques et les livres prophétiques',
    christian_scriptures: 'L\'Évangile et les lettres apostoliques',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: 'Sur quoi aimeriez-vous être interrogé?',
    category: 'Catégorie',
    no_difficulties: 'Aucune difficulté trouvée.',
    select_your_challenge: 'Sélectionnez votre défi',
    choose_difficulty_description: 'Choisissez le niveau de difficulté qui correspond le mieux à vos connaissances bibliques',
    easy: 'Facile',
    easy_desc: 'Parfait pour les débutants',
    medium: 'Moyen',
    medium_desc: 'Pour les joueurs réguliers',
    hard: 'Difficile',
    hard_desc: 'Un vrai défi!',
    
    // Game Modes
    solo: 'Jeu solo',
    multiplayer: 'Multijoueur',
    
    // Common UI Elements
    loading: 'Chargement...',
    loadingApp: 'Chargement de Kingdom Bible Quiz...',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Avertissement', 
    info: 'Info',
    player: 'Joueur',
    user: 'Utilisateur',
    
    // Accessibility Labels
    backButton: 'Retour',
    closeButton: 'Fermer',
    userAvatar: 'Avatar utilisateur',
    playerLabel: 'Joueur',
    
    // Invite Modal
    inviteFriends: 'Inviter des amis',
    roomCode: 'Code de salon',
    shareThisCode: 'Partagez ce code avec des amis pour rejoindre votre jeu',
    shareVia: 'Partager via:',
    inviteAppFriend: 'Inviter un ami de l\'app',
    shareViaMessage: 'Partager par message',
    shareViaEmail: 'Partager par email',
    copied: 'Copié!',
    copy: 'Copier',
    
    // Achievement Badge
    earnedOn: 'Obtenu le',
    
    // Mastery Chart
    testamentMastery: 'Maîtrise du Testament',
    bookMastery: 'Maîtrise du Livre',
    categoryMastery: 'Maîtrise de la Catégorie',
    noMasteryData: 'Aucune donnée de maîtrise disponible pour le moment.',
    
    // Chat
    messageInputField: 'Champ de saisie de message',
    pressEnterToSend: 'Appuyez sur Entrée pour envoyer le message',
    
    // App Logo
    appLogo: 'Logo de l\'App Kingdom Bible Quiz',
    
    // Common nested object for common.loading, common.retry, etc.
    common: {
      // loading: 'Chargement', // Already defined at line 261
      retry: 'Réessayer',
    },
    
    // Quiz UI
    loading_quiz: 'Chargement du quiz...',
    quiz_complete: 'Quiz terminé!',
    well_done: 'Bien joué!',
    question_progress: 'Question {current} sur {total}',
    seconds: 's',
    time_remaining: 'Temps restant',
    explanation: 'Explication',
    next_question: 'Question suivante',
    
    // Accessibility
    select_book_hint: 'Appuyez pour sélectionner ce livre de la Bible',
    no_testament_error: 'Aucun testament sélectionné. Veuillez revenir en arrière et choisir l\'Ancien ou le Nouveau Testament.',
    
    // Book Selection Screen
    old_testament_display: 'ANCIEN TESTAMENT',
    new_testament_display: 'NOUVEAU TESTAMENT', 
    popular: 'Populaire',
    chapters: 'chapitres',
    scripture_study: 'Étude des Écritures',
    
    // Bible Book Themes
    creation_origins: 'Création & Origines',
    freedom_law: 'Liberté & Loi',
    holiness_worship: 'Sainteté & Adoration',
    journey_faith: 'Voyage & Foi',
    covenant_law: 'Alliance & Loi',
    conquest_victory: 'Conquête & Victoire',
    leadership_cycles: 'Leadership & Cycles',
    love_loyalty: 'Amour & Loyauté',
    worship_prayer: 'Adoration & Prière',
    wisdom_life: 'Sagesse & Vie',
    king_kingdom: 'Roi & Royaume',
    servant_action: 'Serviteur & Action',
    savior_compassion: 'Sauveur & Compassion',
    son_god_love: 'Fils de Dieu & Amour',
    church_mission: 'Église & Mission',
    gospel_grace: 'Évangile & Grâce',
    victory_glory: 'Victoire & Gloire',
  },
  
  es: {
    retry: 'Reintentar',
    ok: 'OK',
    none: 'Ninguna',
    previous: 'Anterior',
    top: 'Top',
    noQuestionsAvailable: 'No hay preguntas disponibles para esta selección.',
    inviteFriendPrompt: 'Invitar a un amigo',
    enterFriendId: 'Introduce el ID de usuario de tu amigo:',
    send: 'Enviar',
    inviteSuccess: 'Éxito',
    inviteSuccessMessage: '¡Invitación de partida enviada a tu amigo!',
    inviteError: 'Error',
    inviteErrorMessage: 'No se pudo enviar la notificación de invitación.',
    progressChartData: 'Aquí se mostrarán los datos del gráfico de progreso',
    winner: 'Ganador',
    completed: 'Completado',
    didNotParticipate: 'No participó',
    leaderboard: 'Clasificación',
    correct: 'Correcto',
    time: 'Tiempo',
    you: 'Tú',
    creation_origins: 'Creación y orígenes',
    freedom_law: 'Libertad y ley',
    holiness_worship: 'Santidad y adoración',
    journey_faith: 'Camino y fe',
    covenant_law: 'Pacto y ley',
    conquest_victory: 'Conquista y victoria',
    leadership_cycles: 'Liderazgo y ciclos',
    love_loyalty: 'Amor y lealtad',
    worship_prayer: 'Adoración y oración',
    wisdom_life: 'Sabiduría y vida',
    king_kingdom: 'Rey y reino',
    servant_action: 'Siervo y acción',
    savior_compassion: 'Salvador y compasión',
    son_god_love: 'Hijo de Dios y amor',
    church_mission: 'Iglesia y misión',
    gospel_grace: 'Evangelio y gracia',
    victory_glory: 'Victoria y gloria',
    accuracy: 'Precisión',
    chartPlaceholder: 'Aquí se mostrarán los datos del gráfico de progreso',
    currentLanguage: 'Idioma actual',
    progressOverTime: 'Progreso a lo largo del tiempo',
    score: 'Puntuación',
    tapToChangeLanguage: 'Toca para cambiar el idioma',
    // Authentication
    signIn: 'Iniciar Sesión',
    signUp: 'Registrarse',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    name: 'Nombre',
    preferredLanguage: 'Idioma Preferido',
    createAccount: 'Crear Cuenta',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    dontHaveAccount: '¿No tienes una cuenta?',
    welcomeBack: '¡Bienvenido de vuelta! Inicia sesión para continuar tu viaje espiritual',
    joinKingdom: '¡Únete a Kingdom Bible Quiz! Crea tu cuenta para comenzar tu viaje',
    howShouldWeCallYou: '¿Cómo deberíamos llamarte?',
    
    // Navigation
    back: 'Atrás',
    next: 'Siguiente',
    continue: 'Continuar',
    finish: 'Finalizar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    save: 'Guardar',    
    // Main Navigation
    solo_play: 'Juego Solo',
    friends_family_play: 'Amigos y Familia',
    play: 'Jugar',
    together: 'Juntos',
    me: 'Yo',
    live: 'En Vivo',
    solo_testament_info: '¡Estudia a tu ritmo con aprendizaje bíblico enfocado!',
    multiplayer_testament_info: '¡Desafía a tus amigos y familia con estudio bíblico dirigido!',
    challenge_testament_info: '¡Crea un desafío personal con temas bíblicos enfocados!',
    share: 'Compartir',
    community: 'Comunidad',
    more: 'Más',
    continue_journey: 'Continúa Tu Camino',
    explore: 'Explorar',
    daily_challenge_label: 'Desafío diario',
    start_todays_challenge: 'Comenzar el desafío de hoy',
    resume_last_topic: 'Continuar último tema',
    local_progress_title: 'Progreso local',
    local_progress_subtitle: 'Este progreso permanece en este dispositivo hasta que inicies sesión.',
    quizzes_completed_label: 'Quizzes completados',
    recovery_welcome_back: 'Bienvenido de nuevo',
    recovery_saved_progress_found: 'Encontramos tu progreso guardado de una sesión anterior.',
    recovery_sign_in_restore: 'Inicia sesión con {{provider}} para restaurar tu progreso.',
    recovery_sign_in_restore_cta: 'Iniciar sesión con {{provider}}',
    recovery_skip_restore: 'Seguir jugando sin restaurar',

    // Testament Screen
    header: '¿Qué parte de la Biblia?',
    old: 'Antiguo Testamento',
    old_desc: 'Libros desde Génesis hasta Malaquías',
    new: 'Nuevo Testamento',
    new_desc: 'Libros desde Mateo hasta Apocalipsis',
    books_of_the_bible: 'Libros de la Biblia',
    books_of_the_bible_desc: 'Todos los libros desde Génesis hasta Apocalipsis',
    general: 'General',
    general_description: 'Cuestionarios sobre varios temas y tópicos bíblicos',
    books_focus_description: 'Estudia libros específicos de la Biblia',
    begin_journey: 'Comienza tu viaje',
    choose_your_path: 'Elige tu camino',
    explore_gods_word: 'Explora la Palabra de Dios',
    old_testament: 'Antiguo Testamento',
    new_testament: 'Nuevo Testamento',
    hebrew_scriptures: 'Las Escrituras hebreas y los libros proféticos',
    christian_scriptures: 'El Evangelio y las cartas apostólicas',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: '¿Sobre qué te gustaría ser evaluado?',
    category: 'Categoría',
    no_difficulties: 'No se encontraron dificultades.',
    select_your_challenge: 'Selecciona tu desafío',
    choose_difficulty_description: 'Elige el nivel de dificultad que mejor se adapte a tu conocimiento bíblico',
    easy: 'Fácil',
    easy_desc: 'Perfecto para principiantes',
    medium: 'Medio',
    medium_desc: 'Para jugadores regulares',
    hard: 'Difícil',
    hard_desc: '¡Un verdadero desafío!',
    
    // Game Modes
    solo: 'Juego individual',
    multiplayer: 'Multijugador',
    
    // Common UI Elements
    loading: 'Cargando...',
    loadingApp: 'Cargando Kingdom Bible Quiz...',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    player: 'Jugador',
    user: 'Usuario',
    
    // Accessibility Labels
    backButton: 'Atrás',
    closeButton: 'Cerrar',
    userAvatar: 'Avatar de usuario',
    playerLabel: 'Jugador',
    
    // Invite Modal
    inviteFriends: 'Invitar amigos',
    roomCode: 'Código de sala',
    shareThisCode: 'Comparte este código con amigos para unirse a tu juego',
    shareVia: 'Compartir vía:',
    inviteAppFriend: 'Invitar amigo de la app',
    shareViaMessage: 'Compartir por mensaje',
    shareViaEmail: 'Compartir por email',
    copied: '¡Copiado!',
    copy: 'Copiar',
    
    // Achievement Badge
    earnedOn: 'Obtenido el',
    
    // Mastery Chart
    testamentMastery: 'Dominio del Testamento',
    bookMastery: 'Dominio del Libro',
    categoryMastery: 'Dominio de la Categoría',
    noMasteryData: 'No hay datos de dominio disponibles aún.',
    
    // Chat
    messageInputField: 'Campo de entrada de mensaje',
    pressEnterToSend: 'Presiona Enter para enviar mensaje',
    
    // App Logo
    appLogo: 'Logo de la App Kingdom Bible Quiz',
    
    // Common nested object for common.loading, common.retry, etc.
    common: {
      // loading: 'Cargando', // Already defined at line 429
      retry: 'Reintentar',
    },
    
    // Accessibility
    select_book_hint: 'Toca para seleccionar este libro de la Biblia',
    no_testament_error: 'No se seleccionó ningún testamento. Por favor, regresa y elige el Antiguo o Nuevo Testamento.',
    
    // Book Selection Screen
    old_testament_display: 'ANTIGUO TESTAMENTO',
    new_testament_display: 'NUEVO TESTAMENTO', 
    popular: 'Popular',
    chapters: 'capítulos',
    scripture_study: 'Estudio de las Escrituras',
    
    // Quiz UI
    loading_quiz: 'Cargando cuestionario...',
    quiz_complete: '¡Cuestionario completo!',
    well_done: '¡Bien hecho!',
    question_progress: 'Pregunta {current} de {total}',
    seconds: 's',
    time_remaining: 'Tiempo restante',
    explanation: 'Explicación',
    next_question: 'Siguiente pregunta',
  },
  
  de: {
    retry: 'Erneut versuchen',
    ok: 'OK',
    none: 'Keine',
    previous: 'Vorheriger',
    top: 'Top',
    noQuestionsAvailable: 'Für diese Auswahl sind keine Fragen verfügbar.',
    common: {
      retry: 'Erneut versuchen',
    },
    inviteFriendPrompt: 'Freund einladen',
    enterFriendId: 'Gib die Nutzer-ID deines Freundes ein:',
    send: 'Senden',
    inviteSuccess: 'Erfolg',
    inviteSuccessMessage: 'Spieleinladung an deinen Freund gesendet!',
    inviteError: 'Fehler',
    inviteErrorMessage: 'Einladungsbenachrichtigung konnte nicht gesendet werden.',
    messageInputField: 'Eingabefeld für Nachricht',
    pressEnterToSend: 'Drücke die Eingabetaste, um die Nachricht zu senden',
    appLogo: 'Kingdom-Bible-Quiz-App-Logo',
    progressChartData: 'Hier werden die Daten des Fortschrittsdiagramms angezeigt',
    inviteFriends: 'Freunde einladen',
    roomCode: 'Raumcode',
    shareThisCode: 'Teile diesen Code mit Freunden, damit sie deinem Spiel beitreten',
    shareVia: 'Teilen über:',
    inviteAppFriend: 'App-Freund einladen',
    shareViaMessage: 'Per Nachricht teilen',
    shareViaEmail: 'Per E-Mail teilen',
    copied: 'Kopiert!',
    copy: 'Kopieren',
    earnedOn: 'Erhalten am',
    testamentMastery: 'Testament-Meisterschaft',
    bookMastery: 'Buch-Meisterschaft',
    categoryMastery: 'Kategorie-Meisterschaft',
    noMasteryData: 'Noch keine Meisterschaftsdaten verfügbar.',
    winner: 'Gewinner',
    completed: 'Abgeschlossen',
    didNotParticipate: 'Nicht teilgenommen',
    leaderboard: 'Rangliste',
    correct: 'Richtig',
    time: 'Zeit',
    you: 'Du',
    creation_origins: 'Schöpfung & Ursprünge',
    freedom_law: 'Freiheit & Gesetz',
    holiness_worship: 'Heiligkeit & Anbetung',
    journey_faith: 'Reise & Glaube',
    covenant_law: 'Bund & Gesetz',
    conquest_victory: 'Eroberung & Sieg',
    leadership_cycles: 'Führung & Zyklen',
    love_loyalty: 'Liebe & Treue',
    worship_prayer: 'Anbetung & Gebet',
    wisdom_life: 'Weisheit & Leben',
    king_kingdom: 'König & Königreich',
    servant_action: 'Diener & Tat',
    savior_compassion: 'Retter & Mitgefühl',
    son_god_love: 'Sohn Gottes & Liebe',
    church_mission: 'Gemeinde & Mission',
    gospel_grace: 'Evangelium & Gnade',
    victory_glory: 'Sieg & Herrlichkeit',
    accuracy: 'Genauigkeit',
    chartPlaceholder: 'Hier werden die Daten des Fortschrittsdiagramms angezeigt',
    currentLanguage: 'Aktuelle Sprache',
    progressOverTime: 'Fortschritt im Zeitverlauf',
    score: 'Punktzahl',
    tapToChangeLanguage: 'Tippen, um die Sprache zu ändern',
    // Authentication
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    email: 'E-Mail',
    password: 'Passwort',
    name: 'Name',
    preferredLanguage: 'Bevorzugte Sprache',
    createAccount: 'Konto Erstellen',
    alreadyHaveAccount: 'Haben Sie bereits ein Konto?',
    dontHaveAccount: 'Haben Sie kein Konto?',
    welcomeBack: 'Willkommen zurück! Melden Sie sich an, um Ihre spirituelle Reise fortzusetzen',
    joinKingdom: 'Treten Sie Kingdom Bible Quiz bei! Erstellen Sie Ihr Konto, um Ihre Reise zu beginnen',
    howShouldWeCallYou: 'Wie sollen wir Sie nennen?',
    
    // Navigation
    back: 'Zurück',
    next: 'Weiter',
    continue: 'Fortsetzen',
    finish: 'Beenden',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    close: 'Schließen',
    save: 'Speichern',    
    // Main Navigation
    solo_play: 'Solo Spiel',
    friends_family_play: 'Freunde & Familie',
    play: 'Spielen',
    together: 'Zusammen',
    me: 'Ich',
    live: 'Live',
    solo_testament_info: 'Lerne in deinem eigenen Tempo mit fokussiertem Bibelstudium!',
    multiplayer_testament_info: 'Fordere deine Freunde und Familie mit gezieltem Bibelstudium heraus!',
    challenge_testament_info: 'Erstelle eine persönliche Herausforderung mit fokussierten Bibelthemen!',
    share: 'Teilen',
    community: 'Gemeinschaft',
    more: 'Mehr',
    continue_journey: 'Setze Deine Reise Fort',
    explore: 'Entdecken',

    // Testament Screen
    header: 'Welcher Teil der Bibel?',
    old: 'Altes Testament',
    old_desc: 'Bücher von Genesis bis Maleachi',
    new: 'Neues Testament',
    new_desc: 'Bücher von Matthäus bis Offenbarung',
    books_of_the_bible: 'Bücher der Bibel',
    books_of_the_bible_desc: 'Alle Bücher von Genesis bis Offenbarung',
    general: 'Allgemein',
    general_description: 'Quiz über verschiedene biblische Themen',
    books_focus_description: 'Studiere spezifische Bücher der Bibel',
    begin_journey: 'Beginne deine Reise',
    choose_your_path: 'Wähle deinen Weg',
    explore_gods_word: 'Entdecke Gottes Wort',
    daily_challenge_label: 'Tägliche Herausforderung',
    start_todays_challenge: 'Heutige Herausforderung starten',
    resume_last_topic: 'Letztes Thema fortsetzen',
    local_progress_title: 'Lokaler Fortschritt',
    local_progress_subtitle: 'Dieser Fortschritt bleibt auf diesem Gerät, bis du dich anmeldest.',
    quizzes_completed_label: 'Abgeschlossene Quizze',
    recovery_welcome_back: 'Willkommen zurück',
    recovery_saved_progress_found: 'Wir haben deinen gespeicherten Fortschritt aus einer früheren Sitzung gefunden.',
    recovery_sign_in_restore: 'Melde dich mit {{provider}} an, um deinen Fortschritt wiederherzustellen.',
    recovery_sign_in_restore_cta: 'Mit {{provider}} anmelden',
    recovery_skip_restore: 'Ohne Wiederherstellung weiterspielen',
    old_testament: 'Altes Testament',
    new_testament: 'Neues Testament',
    hebrew_scriptures: 'Die hebräischen Schriften und prophetischen Bücher',
    christian_scriptures: 'Das Evangelium und die apostolischen Briefe',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: 'Worüber möchtest du befragt werden?',
    category: 'Kategorie',
    no_difficulties: 'Keine Schwierigkeitsgrade gefunden.',
    select_your_challenge: 'Wähle deine Herausforderung',
    choose_difficulty_description: 'Wähle den Schwierigkeitsgrad, der am besten zu deinem biblischen Wissen passt',
    easy: 'Leicht',
    easy_desc: 'Perfekt für Anfänger',
    medium: 'Mittel',
    medium_desc: 'Für regelmäßige Spieler',
    hard: 'Schwer',
    hard_desc: 'Eine echte Herausforderung!',
    
    // Game Modes
    solo: 'Einzelspiel',
    multiplayer: 'Mehrspieler',
    
    // Common UI Elements
    loading: 'Laden...',
    loadingApp: 'Kingdom Bible Quiz wird geladen...',
    error: 'Fehler',
    success: 'Erfolg',
    warning: 'Warnung',
    info: 'Info',
    player: 'Spieler',
    user: 'Benutzer',
    
    // Accessibility Labels
    backButton: 'Zurück',
    closeButton: 'Schließen',
    userAvatar: 'Benutzer-Avatar',
    playerLabel: 'Spieler',
    
    // Accessibility
    select_book_hint: 'Tippe, um dieses Bibelbuch auszuwählen',
    no_testament_error: 'Kein Testament ausgewählt. Bitte gehe zurück und wähle das Alte oder Neue Testament.',
    
    // Book Selection Screen
    old_testament_display: 'ALTES TESTAMENT',
    new_testament_display: 'NEUES TESTAMENT', 
    popular: 'Beliebt',
    chapters: 'Kapitel',
    scripture_study: 'Schriftstudium',
    
    // Quiz UI
    loading_quiz: 'Quiz wird geladen...',
    quiz_complete: 'Quiz abgeschlossen!',
    well_done: 'Gut gemacht!',
    question_progress: 'Frage {current} von {total}',
    seconds: 's',
    time_remaining: 'Verbleibende Zeit',
    explanation: 'Erklärung',
    next_question: 'Nächste Frage',
  },
  
  pt: {
    retry: 'Tentar novamente',
    ok: 'OK',
    none: 'Nenhuma',
    previous: 'Anterior',
    top: 'Top',
    noQuestionsAvailable: 'Não há perguntas disponíveis para esta seleção.',
    common: {
      retry: 'Tentar novamente',
    },
    inviteFriendPrompt: 'Convidar amigo',
    enterFriendId: 'Digite o ID de usuário do seu amigo:',
    send: 'Enviar',
    inviteSuccess: 'Sucesso',
    inviteSuccessMessage: 'Convite para o jogo enviado ao seu amigo!',
    inviteError: 'Erro',
    inviteErrorMessage: 'Falha ao enviar a notificação de convite.',
    progressChartData: 'Os dados do gráfico de progresso serão exibidos aqui',
    winner: 'Vencedor',
    completed: 'Concluído',
    didNotParticipate: 'Não participou',
    leaderboard: 'Ranking',
    correct: 'Correto',
    time: 'Tempo',
    you: 'Você',
    creation_origins: 'Criação e origens',
    freedom_law: 'Liberdade e lei',
    holiness_worship: 'Santidade e adoração',
    journey_faith: 'Jornada e fé',
    covenant_law: 'Aliança e lei',
    conquest_victory: 'Conquista e vitória',
    leadership_cycles: 'Liderança e ciclos',
    love_loyalty: 'Amor e lealdade',
    worship_prayer: 'Adoração e oração',
    wisdom_life: 'Sabedoria e vida',
    king_kingdom: 'Rei e reino',
    servant_action: 'Servo e ação',
    savior_compassion: 'Salvador e compaixão',
    son_god_love: 'Filho de Deus e amor',
    church_mission: 'Igreja e missão',
    gospel_grace: 'Evangelho e graça',
    victory_glory: 'Vitória e glória',
    accuracy: 'Precisão',
    chartPlaceholder: 'Os dados do gráfico de progresso serão exibidos aqui',
    currentLanguage: 'Idioma atual',
    progressOverTime: 'Progresso ao longo do tempo',
    score: 'Pontuação',
    tapToChangeLanguage: 'Toque para mudar o idioma',
    // Authentication
    signIn: 'Entrar',
    signUp: 'Cadastrar',
    email: 'Email',
    password: 'Senha',
    name: 'Nome',
    preferredLanguage: 'Idioma Preferido',
    createAccount: 'Criar Conta',
    alreadyHaveAccount: 'Já tem uma conta?',
    dontHaveAccount: 'Não tem uma conta?',
    welcomeBack: 'Bem-vindo de volta! Faça login para continuar sua jornada espiritual',
    joinKingdom: 'Junte-se ao Kingdom Bible Quiz! Crie sua conta para começar sua jornada',
    howShouldWeCallYou: 'Como devemos chamá-lo?',
    
    // Navigation
    back: 'Voltar',
    next: 'Próximo',
    continue: 'Continuar',
    finish: 'Finalizar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Fechar',
    save: 'Salvar',    
    // Main Navigation
    solo_play: 'Jogo Solo',
    friends_family_play: 'Amigos e Família',
    play: 'Jogar',
    together: 'Juntos',
    me: 'Eu',
    live: 'Ao Vivo',
    solo_testament_info: 'Estude no seu ritmo com aprendizado bíblico focado!',
    multiplayer_testament_info: 'Desafie seus amigos e família com estudo bíblico direcionado!',
    challenge_testament_info: 'Crie um desafio pessoal com temas bíblicos focados!',
    share: 'Compartilhar',
    community: 'Comunidade',
    more: 'Mais',
    continue_journey: 'Continue Sua Jornada',
    explore: 'Explorar',

    // Testament Screen
    header: 'Qual parte da Bíblia?',
    old: 'Antigo Testamento',
    old_desc: 'Livros de Gênesis a Malaquias',
    new: 'Novo Testamento',
    new_desc: 'Livros de Mateus a Apocalipse',
    books_of_the_bible: 'Livros da Bíblia',
    books_of_the_bible_desc: 'Todos os livros de Gênesis a Apocalipse',
    general: 'Geral',
    general_description: 'Quiz sobre vários temas e tópicos bíblicos',
    books_focus_description: 'Estude livros específicos da Bíblia',
    begin_journey: 'Comece sua jornada',
    choose_your_path: 'Escolha seu caminho',
    explore_gods_word: 'Explore a Palavra de Deus',
    daily_challenge_label: 'Desafio diário',
    start_todays_challenge: 'Começar o desafio de hoje',
    resume_last_topic: 'Continuar último tópico',
    local_progress_title: 'Progresso local',
    local_progress_subtitle: 'Este progresso fica neste dispositivo até você entrar na sua conta.',
    quizzes_completed_label: 'Quizzes concluídos',
    recovery_welcome_back: 'Bem-vindo de volta',
    recovery_saved_progress_found: 'Encontramos seu progresso salvo de uma sessão anterior.',
    recovery_sign_in_restore: 'Entre com {{provider}} para restaurar seu progresso.',
    recovery_sign_in_restore_cta: 'Entrar com {{provider}}',
    recovery_skip_restore: 'Continuar jogando sem restaurar',
    old_testament: 'Antigo Testamento',
    new_testament: 'Novo Testamento',
    hebrew_scriptures: 'As Escrituras Hebraicas e os Livros Proféticos',
    christian_scriptures: 'O Evangelho e as Cartas Apostólicas',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: 'Sobre o que você gostaria de ser questionado?',
    category: 'Categoria',
    no_difficulties: 'Nenhuma dificuldade encontrada.',
    select_your_challenge: 'Selecione seu desafio',
    choose_difficulty_description: 'Escolha o nível de dificuldade que melhor corresponde ao seu conhecimento bíblico',
    easy: 'Fácil',
    easy_desc: 'Perfeito para iniciantes',
    medium: 'Médio',
    medium_desc: 'Para jogadores regulares',
    hard: 'Difícil',
    hard_desc: 'Um verdadeiro desafio!',
    
    // Game Modes
    solo: 'Jogo Individual',
    multiplayer: 'Multijogador',
    
    // Common UI Elements
    loading: 'Carregando...',
    loadingApp: 'Carregando Kingdom Bible Quiz...',
    error: 'Erro',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',
    player: 'Jogador',
    user: 'Usuário',
    
    // Accessibility Labels
    backButton: 'Voltar',
    closeButton: 'Fechar',
    userAvatar: 'Avatar do usuário',
    playerLabel: 'Jogador',
    
    // Invite Modal
    inviteFriends: 'Convidar amigos',
    roomCode: 'Código da sala',
    shareThisCode: 'Compartilhe este código com amigos para entrar no seu jogo',
    shareVia: 'Compartilhar via:',
    inviteAppFriend: 'Convidar amigo do app',
    shareViaMessage: 'Compartilhar por mensagem',
    shareViaEmail: 'Compartilhar por email',
    copied: 'Copiado!',
    copy: 'Copiar',
    
    // Achievement Badge
    earnedOn: 'Conquistado em',
    
    // Mastery Chart
    testamentMastery: 'Domínio do Testamento',
    bookMastery: 'Domínio do Livro',
    categoryMastery: 'Domínio da Categoria',
    noMasteryData: 'Nenhum dado de domínio disponível ainda.',
    
    // Chat
    messageInputField: 'Campo de entrada de mensagem',
    pressEnterToSend: 'Pressione Enter para enviar mensagem',
    
    // App Logo
    appLogo: 'Logo do App Kingdom Bible Quiz',
    
    // Accessibility
    select_book_hint: 'Toque para selecionar este livro da Bíblia',
    no_testament_error: 'Nenhum testamento selecionado. Por favor, volte e escolha o Antigo ou Novo Testamento.',
    
    // Book Selection Screen
    old_testament_display: 'ANTIGO TESTAMENTO',
    new_testament_display: 'NOVO TESTAMENTO', 
    popular: 'Popular',
    chapters: 'capítulos',
    scripture_study: 'Estudo das Escrituras',
    
    // Quiz UI
    loading_quiz: 'Carregando questionário...',
    quiz_complete: 'Questionário completo!',
    well_done: 'Muito bem!',
    question_progress: 'Pergunta {current} de {total}',
    seconds: 's',
    time_remaining: 'Tempo restante',
    explanation: 'Explicação',
    next_question: 'Próxima pergunta',
  },
  
  ru: {
    retry: 'Повторить',
    ok: 'ОК',
    none: 'Нет',
    previous: 'Предыдущий',
    top: 'Топ',
    noQuestionsAvailable: 'Для этого выбора нет доступных вопросов.',
    common: {
      retry: 'Повторить',
    },
    inviteFriendPrompt: 'Пригласить друга',
    enterFriendId: 'Введите ID пользователя вашего друга:',
    send: 'Отправить',
    inviteSuccess: 'Готово',
    inviteSuccessMessage: 'Приглашение в игру отправлено вашему другу!',
    inviteError: 'Ошибка',
    inviteErrorMessage: 'Не удалось отправить уведомление о приглашении.',
    messageInputField: 'Поле ввода сообщения',
    pressEnterToSend: 'Нажмите Enter, чтобы отправить сообщение',
    appLogo: 'Логотип приложения Kingdom Bible Quiz',
    progressChartData: 'Здесь будут показаны данные графика прогресса',
    share: 'Поделиться',
    inviteFriends: 'Пригласить друзей',
    roomCode: 'Код комнаты',
    shareThisCode: 'Поделитесь этим кодом с друзьями, чтобы они присоединились к игре',
    shareVia: 'Поделиться через:',
    inviteAppFriend: 'Пригласить друга из приложения',
    shareViaMessage: 'Поделиться сообщением',
    shareViaEmail: 'Поделиться по e-mail',
    copied: 'Скопировано!',
    copy: 'Копировать',
    earnedOn: 'Получено',
    testamentMastery: 'Освоение Завета',
    bookMastery: 'Освоение книг',
    categoryMastery: 'Освоение категорий',
    noMasteryData: 'Данных об освоении пока нет.',
    winner: 'Победитель',
    completed: 'Завершено',
    didNotParticipate: 'Не участвовал',
    leaderboard: 'Таблица лидеров',
    correct: 'Верно',
    time: 'Время',
    you: 'Вы',
    creation_origins: 'Сотворение и истоки',
    freedom_law: 'Свобода и закон',
    holiness_worship: 'Святость и поклонение',
    journey_faith: 'Путь и вера',
    covenant_law: 'Завет и закон',
    conquest_victory: 'Завоевание и победа',
    leadership_cycles: 'Лидерство и циклы',
    love_loyalty: 'Любовь и верность',
    worship_prayer: 'Поклонение и молитва',
    wisdom_life: 'Мудрость и жизнь',
    king_kingdom: 'Царь и царство',
    servant_action: 'Слуга и действие',
    savior_compassion: 'Спаситель и сострадание',
    son_god_love: 'Сын Божий и любовь',
    church_mission: 'Церковь и миссия',
    gospel_grace: 'Евангелие и благодать',
    victory_glory: 'Победа и слава',
    accuracy: 'Точность',
    chartPlaceholder: 'Здесь будут показаны данные графика прогресса',
    currentLanguage: 'Текущий язык',
    progressOverTime: 'Прогресс со временем',
    score: 'Счёт',
    tapToChangeLanguage: 'Нажмите, чтобы сменить язык',
    // Authentication
    signIn: 'Войти',
    signUp: 'Регистрация',
    email: 'Электронная Почта',
    password: 'Пароль',
    name: 'Имя',
    preferredLanguage: 'Предпочтительный Язык',
    createAccount: 'Создать Аккаунт',
    alreadyHaveAccount: 'У вас уже есть аккаунт?',
    dontHaveAccount: 'У вас нет аккаунта?',
    welcomeBack: 'Добро пожаловать обратно! Войдите, чтобы продолжить ваше духовное путешествие',
    joinKingdom: 'Присоединяйтесь к Kingdom Bible Quiz! Создайте аккаунт, чтобы начать ваше путешествие',
    howShouldWeCallYou: 'Как нам вас называть?',
    
    // Navigation
    back: 'Назад',
    next: 'Далее',
    continue: 'Продолжить',
    finish: 'Завершить',
    cancel: 'Отменить',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    save: 'Сохранить',    
    // Main Navigation
    solo_play: 'Одиночная Игра',
    friends_family_play: 'Друзья и Семья',
    play: 'Играть',
    together: 'Вместе',
    me: 'Я',
    live: 'Прямой Эфир',
    solo_testament_info: 'Изучайте в своём темпе с целенаправленным изучением Библии!',
    multiplayer_testament_info: 'Бросьте вызов друзьям и семье с целенаправленным изучением Библии!',
    challenge_testament_info: 'Создайте личный вызов с целенаправленными библейскими темами!',
    community: 'Сообщество',
    more: 'Ещё',
    continue_journey: 'Продолжите Свой Путь',
    explore: 'Обзор',

    // Testament Screen
    header: 'Какая часть Библии?',
    old: 'Ветхий Завет',
    old_desc: 'Книги от Бытия до Малахии',
    new: 'Новый Завет',
    new_desc: 'Книги от Матфея до Откровения',
    books_of_the_bible: 'Книги Библии',
    books_of_the_bible_desc: 'Все книги от Бытия до Откровения',
    general: 'Общие',
    general_description: 'Викторина по различным библейским темам',
    books_focus_description: 'Изучайте конкретные книги Библии',
    begin_journey: 'Начните свое путешествие',
    choose_your_path: 'Выберите свой путь',
    explore_gods_word: 'Исследуйте Слово Божье',
    daily_challenge_label: 'Ежедневное испытание',
    start_todays_challenge: 'Начать сегодняшнее испытание',
    resume_last_topic: 'Продолжить последнюю тему',
    local_progress_title: 'Локальный прогресс',
    local_progress_subtitle: 'Этот прогресс хранится на этом устройстве, пока вы не войдёте в аккаунт.',
    quizzes_completed_label: 'Пройдено викторин',
    recovery_welcome_back: 'С возвращением',
    recovery_saved_progress_found: 'Мы нашли ваш сохранённый прогресс из предыдущего сеанса.',
    recovery_sign_in_restore: 'Войдите через {{provider}}, чтобы восстановить прогресс.',
    recovery_sign_in_restore_cta: 'Войти через {{provider}}',
    recovery_skip_restore: 'Играть дальше без восстановления',
    old_testament: 'Ветхий Завет',
    new_testament: 'Новый Завет',
    hebrew_scriptures: 'Еврейские Писания и пророческие книги',
    christian_scriptures: 'Евангелие и апостольские послания',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: 'По чему вы хотите пройти тест?',
    category: 'Категория',
    no_difficulties: 'Уровни сложности не найдены.',
    select_your_challenge: 'Выберите свой вызов',
    choose_difficulty_description: 'Выберите уровень сложности, который лучше всего соответствует вашим библейским знаниям',
    easy: 'Легко',
    easy_desc: 'Отлично для начинающих',
    medium: 'Средний',
    medium_desc: 'Для обычных игроков',
    hard: 'Сложный',
    hard_desc: 'Настоящий вызов!',
    
    // Game Modes
    solo: 'Одиночная игра',
    multiplayer: 'Многопользовательская',
    
    // Common UI Elements
    loading: 'Загрузка...',
    loadingApp: 'Загрузка Kingdom Bible Quiz...',
    error: 'Ошибка',
    success: 'Успех',
    warning: 'Предупреждение',
    info: 'Информация',
    player: 'Игрок',
    user: 'Пользователь',
    
    // Accessibility Labels
    backButton: 'Назад',
    closeButton: 'Закрыть',
    userAvatar: 'Аватар пользователя',
    playerLabel: 'Игрок',
    
    // Accessibility
    select_book_hint: 'Нажмите, чтобы выбрать эту книгу Библии',
    no_testament_error: 'Завет не выбран. Пожалуйста, вернитесь и выберите Ветхий или Новый Завет.',
    
    // Book Selection Screen
    old_testament_display: 'ВЕТХИЙ ЗАВЕТ',
    new_testament_display: 'НОВЫЙ ЗАВЕТ', 
    popular: 'Популярные',
    chapters: 'главы',
    scripture_study: 'Изучение Писания',
    
    // Quiz UI
    loading_quiz: 'Загрузка викторины...',
    quiz_complete: 'Викторина завершена!',
    well_done: 'Отлично!',
    question_progress: 'Вопрос {current} из {total}',
    seconds: 'с',
    time_remaining: 'Осталось времени',
    explanation: 'Объяснение',
    next_question: 'Следующий вопрос',
  },
  
  tl: {
    retry: 'Subukang muli',
    ok: 'OK',
    none: 'Wala',
    previous: 'Nakaraan',
    top: 'Top',
    noQuestionsAvailable: 'Walang available na tanong para sa pagpiling ito.',
    common: {
      retry: 'Subukang muli',
    },
    inviteFriendPrompt: 'Mag-imbita ng Kaibigan',
    enterFriendId: 'Ilagay ang user ID ng iyong kaibigan:',
    send: 'Ipadala',
    inviteSuccess: 'Tagumpay',
    inviteSuccessMessage: 'Naipadala na ang imbitasyon sa laro sa iyong kaibigan!',
    inviteError: 'Error',
    inviteErrorMessage: 'Hindi naipadala ang abiso ng imbitasyon.',
    messageInputField: 'Field ng pag-input ng mensahe',
    pressEnterToSend: 'Pindutin ang Enter para ipadala ang mensahe',
    appLogo: 'Logo ng Kingdom Bible Quiz App',
    progressChartData: 'Dito ipapakita ang data ng chart ng progreso',
    share: 'Ibahagi',
    inviteFriends: 'Mag-imbita ng Kaibigan',
    roomCode: 'Code ng Kuwarto',
    shareThisCode: 'Ibahagi ang code na ito sa mga kaibigan para makasali sa laro mo',
    shareVia: 'Ibahagi sa pamamagitan ng:',
    inviteAppFriend: 'Mag-imbita ng Kaibigan sa App',
    shareViaMessage: 'Ibahagi sa Mensahe',
    shareViaEmail: 'Ibahagi sa Email',
    copied: 'Nakopya!',
    copy: 'Kopyahin',
    earnedOn: 'Nakuha noong',
    testamentMastery: 'Kahusayan sa Tipan',
    bookMastery: 'Kahusayan sa Aklat',
    categoryMastery: 'Kahusayan sa Kategorya',
    noMasteryData: 'Wala pang data ng kahusayan.',
    winner: 'Nanalo',
    completed: 'Tapos na',
    didNotParticipate: 'Hindi Lumahok',
    leaderboard: 'Leaderboard',
    correct: 'Tama',
    time: 'Oras',
    you: 'Ikaw',
    creation_origins: 'Paglikha at Pinagmulan',
    freedom_law: 'Kalayaan at Batas',
    holiness_worship: 'Kabanalan at Pagsamba',
    journey_faith: 'Paglalakbay at Pananampalataya',
    covenant_law: 'Tipan at Batas',
    conquest_victory: 'Pananakop at Tagumpay',
    leadership_cycles: 'Pamumuno at mga Siklo',
    love_loyalty: 'Pag-ibig at Katapatan',
    worship_prayer: 'Pagsamba at Panalangin',
    wisdom_life: 'Karunungan at Buhay',
    king_kingdom: 'Hari at Kaharian',
    servant_action: 'Lingkod at Pagkilos',
    savior_compassion: 'Tagapagligtas at Habag',
    son_god_love: 'Anak ng Diyos at Pag-ibig',
    church_mission: 'Iglesia at Misyon',
    gospel_grace: 'Ebanghelyo at Biyaya',
    victory_glory: 'Tagumpay at Kaluwalhatian',
    accuracy: 'Katumpakan',
    chartPlaceholder: 'Dito ipapakita ang data ng chart ng progreso',
    currentLanguage: 'Kasalukuyang wika',
    progressOverTime: 'Progreso Sa Paglipas ng Panahon',
    score: 'Iskor',
    tapToChangeLanguage: 'I-tap para palitan ang wika',
    // Authentication
    signIn: 'Mag-sign In',
    signUp: 'Mag-sign Up',
    email: 'Email',
    password: 'Password',
    name: 'Pangalan',
    preferredLanguage: 'Gustong Wika',
    createAccount: 'Gumawa ng Account',
    alreadyHaveAccount: 'May account ka na ba?',
    dontHaveAccount: 'Walang account?',
    welcomeBack: 'Maligayang pagbabalik! Mag-sign in para ipagpatuloy ang inyong spiritual journey',
    joinKingdom: 'Sumali sa Kingdom Bible Quiz! Gumawa ng account para simulan ang inyong journey',
    howShouldWeCallYou: 'Paano namin kayo tatawagin?',
    
    // Navigation
    back: 'Bumalik',
    next: 'Susunod',
    continue: 'Magpatuloy',
    finish: 'Tapusin',
    cancel: 'Kanselahin',
    confirm: 'Kumpirmahin',
    close: 'Isara',
    save: 'I-save',    
    // Main Navigation
    solo_play: 'Solo na Laro',
    friends_family_play: 'Mga Kaibigan at Pamilya',
    play: 'Maglaro',
    together: 'Magkasama',
    me: 'Ako',
    live: 'Live',
    solo_testament_info: 'Mag-aral sa sariling bilis mo na may nakatuon na pag-aaral ng Bibliya!',
    multiplayer_testament_info: 'Hamunin ang iyong mga kaibigan at pamilya sa nakatuon na pag-aaral ng Bibliya!',
    challenge_testament_info: 'Gumawa ng personal na hamon sa mga nakatuon na paksa ng Bibliya!',
    community: 'Komunidad',
    more: 'Higit Pa',
    continue_journey: 'Ipagpatuloy ang Iyong Paglalakbay',
    explore: 'Galugarin',

    // Testament Screen
    header: 'Alin na bahagi ng Bibliya?',
    old: 'Lumang Tipan',
    old_desc: 'Mga aklat mula sa Genesis hanggang Malaquias',
    new: 'Bagong Tipan',
    new_desc: 'Mga aklat mula sa Mateo hanggang Pahayag',
    books_of_the_bible: 'Mga Aklat ng Bibliya',
    books_of_the_bible_desc: 'Lahat ng aklat mula sa Genesis hanggang Pahayag',
    general: 'Pangkalahatan',
    general_description: 'Quiz tungkol sa iba\'t ibang paksang biblical',
    books_focus_description: 'Mag-aral ng mga tukoy na aklat ng Bibliya',
    begin_journey: 'Simulan ang inyong paglalakbay',
    choose_your_path: 'Piliin ang inyong daan',
    explore_gods_word: 'Tuklasin ang Salita ng Diyos',
    daily_challenge_label: 'Pang-araw-araw na Hamon',
    start_todays_challenge: 'Simulan ang Hamon Ngayon',
    resume_last_topic: 'Ipagpatuloy ang Huling Paksa',
    local_progress_title: 'Lokal na Progreso',
    local_progress_subtitle: 'Mananatili ang progresong ito sa device na ito hanggang mag-sign in ka.',
    quizzes_completed_label: 'Mga Natapos na Quiz',
    recovery_welcome_back: 'Maligayang Pagbabalik',
    recovery_saved_progress_found: 'Natagpuan namin ang naka-save mong progreso mula sa nakaraang session.',
    recovery_sign_in_restore: 'Mag-sign in gamit ang {{provider}} para maibalik ang iyong progreso.',
    recovery_sign_in_restore_cta: 'Mag-sign in gamit ang {{provider}}',
    recovery_skip_restore: 'Magpatuloy Nang Walang Pagbabalik',
    old_testament: 'Lumang Tipan',
    new_testament: 'Bagong Tipan',
    hebrew_scriptures: 'Ang mga Hebreo na Kasulatan at mga Propetikong Aklat',
    christian_scriptures: 'Ang Ebanghelyo at mga Apostolikong Liham',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: 'Tungkol saan kayo gustong mag-quiz?',
    category: 'Kategorya',
    no_difficulties: 'Walang nahanap na difficulty.',
    select_your_challenge: 'Piliin ang inyong hamon',
    choose_difficulty_description: 'Piliin ang antas ng kahirapan na pinakabagay sa inyong kaalaman sa Bibliya',
    easy: 'Madali',
    easy_desc: 'Mahusay para sa mga nagsisimula',
    medium: 'Katamtaman',
    medium_desc: 'Para sa mga regular na manlalaro',
    hard: 'Mahirap',
    hard_desc: 'Tunay na hamon!',
    
    // Game Modes
    solo: 'Solo na Laro',
    multiplayer: 'Maraming Manlalaro',
    
    // Common UI Elements
    loading: 'Naglo-load...',
    loadingApp: 'Naglo-load ng Kingdom Bible Quiz...',
    error: 'Error',
    success: 'Tagumpay',
    warning: 'Babala',
    info: 'Impormasyon',
    player: 'Manlalaro',
    user: 'User',
    
    // Accessibility Labels
    backButton: 'Bumalik',
    closeButton: 'Isara',
    userAvatar: 'Avatar ng user',
    playerLabel: 'Manlalaro',
    
    // Accessibility
    select_book_hint: 'I-tap para piliin ang aklat ng Bibliya na ito',
    no_testament_error: 'Walang napihing tipan. Mangyaring bumalik at piliin ang Lumang o Bagong Tipan.',
    
    // Book Selection Screen
    old_testament_display: 'LUMANG TIPAN',
    new_testament_display: 'BAGONG TIPAN', 
    popular: 'Sikat',
    chapters: 'kabanata',
    scripture_study: 'Pag-aaral ng Kasulatan',
    
    // Quiz UI
    loading_quiz: 'Naglo-load ng quiz...',
    quiz_complete: 'Tapos na ang quiz!',
    well_done: 'Galing!',
    question_progress: 'Tanong {current} sa {total}',
    seconds: 's',
    time_remaining: 'Natitirang oras',
    explanation: 'Paliwanag',
    next_question: 'Susunod na tanong',
  },
  
  it: {
    retry: 'Riprova',
    ok: 'OK',
    none: 'Nessuna',
    previous: 'Precedente',
    top: 'Top',
    noQuestionsAvailable: 'Nessuna domanda disponibile per questa selezione.',
    common: {
      retry: 'Riprova',
    },
    inviteFriendPrompt: 'Invita un amico',
    enterFriendId: 'Inserisci l\'ID utente del tuo amico:',
    send: 'Invia',
    inviteSuccess: 'Fatto',
    inviteSuccessMessage: 'Invito alla partita inviato al tuo amico!',
    inviteError: 'Errore',
    inviteErrorMessage: 'Impossibile inviare la notifica di invito.',
    messageInputField: 'Campo di inserimento messaggio',
    pressEnterToSend: 'Premi Invio per inviare il messaggio',
    appLogo: 'Logo dell\'app Kingdom Bible Quiz',
    progressChartData: 'Qui verranno mostrati i dati del grafico dei progressi',
    share: 'Condividi',
    inviteFriends: 'Invita amici',
    roomCode: 'Codice stanza',
    shareThisCode: 'Condividi questo codice con gli amici per farli entrare nella tua partita',
    shareVia: 'Condividi tramite:',
    inviteAppFriend: 'Invita un amico dell\'app',
    shareViaMessage: 'Condividi con un messaggio',
    shareViaEmail: 'Condividi via e-mail',
    copied: 'Copiato!',
    copy: 'Copia',
    earnedOn: 'Ottenuto il',
    testamentMastery: 'Padronanza del Testamento',
    bookMastery: 'Padronanza dei libri',
    categoryMastery: 'Padronanza delle categorie',
    noMasteryData: 'Ancora nessun dato di padronanza.',
    winner: 'Vincitore',
    completed: 'Completato',
    didNotParticipate: 'Non ha partecipato',
    leaderboard: 'Classifica',
    correct: 'Corretto',
    time: 'Tempo',
    you: 'Tu',
    creation_origins: 'Creazione e origini',
    freedom_law: 'Libertà e legge',
    holiness_worship: 'Santità e adorazione',
    journey_faith: 'Cammino e fede',
    covenant_law: 'Alleanza e legge',
    conquest_victory: 'Conquista e vittoria',
    leadership_cycles: 'Leadership e cicli',
    love_loyalty: 'Amore e lealtà',
    worship_prayer: 'Adorazione e preghiera',
    wisdom_life: 'Saggezza e vita',
    king_kingdom: 'Re e regno',
    servant_action: 'Servo e azione',
    savior_compassion: 'Salvatore e compassione',
    son_god_love: 'Figlio di Dio e amore',
    church_mission: 'Chiesa e missione',
    gospel_grace: 'Vangelo e grazia',
    victory_glory: 'Vittoria e gloria',
    accuracy: 'Precisione',
    chartPlaceholder: 'Qui verranno mostrati i dati del grafico dei progressi',
    currentLanguage: 'Lingua attuale',
    progressOverTime: 'Progressi nel tempo',
    score: 'Punteggio',
    tapToChangeLanguage: 'Tocca per cambiare lingua',
    // Authentication
    signIn: 'Accedi',
    signUp: 'Registrati',
    email: 'Email',
    password: 'Password',
    name: 'Nome',
    preferredLanguage: 'Lingua Preferita',
    createAccount: 'Crea Account',
    alreadyHaveAccount: 'Hai già un account?',
    dontHaveAccount: 'Non hai un account?',
    welcomeBack: 'Bentornato! Accedi per continuare il tuo viaggio spirituale',
    joinKingdom: 'Unisciti a Kingdom Bible Quiz! Crea il tuo account per iniziare il tuo viaggio',
    howShouldWeCallYou: 'Come dovremmo chiamarti?',
    
    // Navigation
    back: 'Indietro',
    next: 'Avanti',
    continue: 'Continua',
    finish: 'Termina',
    cancel: 'Annulla',
    confirm: 'Conferma',
    close: 'Chiudi',
    save: 'Salva',    
    // Main Navigation
    solo_play: 'Gioco Solo',
    friends_family_play: 'Amici e Famiglia',
    play: 'Gioca',
    together: 'Insieme',
    me: 'Io',
    live: 'Live',
    solo_testament_info: 'Studia al tuo ritmo con un apprendimento biblico mirato!',
    multiplayer_testament_info: 'Sfida i tuoi amici e la tua famiglia con uno studio biblico mirato!',
    challenge_testament_info: 'Crea una sfida personale con argomenti biblici mirati!',
    community: 'Comunità',
    more: 'Altro',
    continue_journey: 'Continua il Tuo Viaggio',
    explore: 'Esplora',

    // Testament Screen
    header: 'Quale parte della Bibbia?',
    old: 'Antico Testamento',
    old_desc: 'Libri da Genesi a Malachia',
    new: 'Nuovo Testamento',
    new_desc: 'Libri da Matteo ad Apocalisse',
    books_of_the_bible: 'Libri della Bibbia',
    books_of_the_bible_desc: 'Tutti i libri da Genesi ad Apocalisse',
    general: 'Generale',
    general_description: 'Quiz su vari temi e argomenti biblici',
    books_focus_description: 'Studia libri specifici della Bibbia',
    begin_journey: 'Inizia il tuo viaggio',
    choose_your_path: 'Scegli il tuo percorso',
    explore_gods_word: 'Esplora la Parola di Dio',
    daily_challenge_label: 'Sfida quotidiana',
    start_todays_challenge: 'Inizia la sfida di oggi',
    resume_last_topic: 'Riprendi l\'ultimo argomento',
    local_progress_title: 'Progressi locali',
    local_progress_subtitle: 'Questi progressi restano su questo dispositivo finché non accedi.',
    quizzes_completed_label: 'Quiz completati',
    recovery_welcome_back: 'Bentornato',
    recovery_saved_progress_found: 'Abbiamo trovato i tuoi progressi salvati di una sessione precedente.',
    recovery_sign_in_restore: 'Accedi con {{provider}} per ripristinare i tuoi progressi.',
    recovery_sign_in_restore_cta: 'Accedi con {{provider}}',
    recovery_skip_restore: 'Continua a giocare senza ripristinare',
    old_testament: 'Antico Testamento',
    new_testament: 'Nuovo Testamento',
    hebrew_scriptures: 'Le Scritture Ebraiche e i Libri Profetici',
    christian_scriptures: 'Il Vangelo e le Lettere Apostoliche',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: 'Su cosa vorresti essere interrogato?',
    category: 'Categoria',
    no_difficulties: 'Nessuna difficoltà trovata.',
    select_your_challenge: 'Seleziona la tua sfida',
    choose_difficulty_description: 'Scegli il livello di difficoltà che meglio corrisponde alla tua conoscenza biblica',
    easy: 'Facile',
    easy_desc: 'Perfetto per i principianti',
    medium: 'Medio',
    medium_desc: 'Per i giocatori regolari',
    hard: 'Difficile',
    hard_desc: 'Una vera sfida!',
    
    // Game Modes
    solo: 'Gioco Singolo',
    multiplayer: 'Multigiocatore',
    
    // Common UI Elements
    loading: 'Caricamento...',
    loadingApp: 'Caricamento Kingdom Bible Quiz...',
    error: 'Errore',
    success: 'Successo',
    warning: 'Avvertimento',
    info: 'Informazioni',
    player: 'Giocatore',
    user: 'Utente',
    
    // Accessibility Labels
    backButton: 'Indietro',
    closeButton: 'Chiudi',
    userAvatar: 'Avatar utente',
    playerLabel: 'Giocatore',
    
    // Accessibility
    select_book_hint: 'Tocca per selezionare questo libro della Bibbia',
    no_testament_error: 'Nessun testamento selezionato. Per favore torna indietro e scegli l\'Antico o Nuovo Testamento.',
    
    // Book Selection Screen
    old_testament_display: 'ANTICO TESTAMENTO',
    new_testament_display: 'NUOVO TESTAMENTO', 
    popular: 'Popolare',
    chapters: 'capitoli',
    scripture_study: 'Studio delle Scritture',
    
    // Quiz UI
    loading_quiz: 'Caricamento quiz...',
    quiz_complete: 'Quiz completato!',
    well_done: 'Ben fatto!',
    question_progress: 'Domanda {current} di {total}',
    seconds: 's',
    time_remaining: 'Tempo rimanente',
    explanation: 'Spiegazione',
    next_question: 'Prossima domanda',
  },
  
  am: {
    retry: 'እንደገና ሞክር',
    ok: 'እሺ',
    none: 'የለም',
    previous: 'ቀዳሚ',
    top: 'ከፍተኛ',
    noQuestionsAvailable: 'ለዚህ ምርጫ የሚገኝ ጥያቄ የለም።',
    common: {
      retry: 'እንደገና ሞክር',
    },
    inviteFriendPrompt: 'ጓደኛ ይጋብዙ',
    enterFriendId: 'የጓደኛዎን የተጠቃሚ መታወቂያ ያስገቡ፦',
    send: 'ላክ',
    inviteSuccess: 'ተሳክቷል',
    inviteSuccessMessage: 'የጨዋታ ግብዣ ለጓደኛዎ ተልኳል!',
    inviteError: 'ስህተት',
    inviteErrorMessage: 'የግብዣ ማሳወቂያውን መላክ አልተቻለም።',
    messageInputField: 'የመልዕክት ማስገቢያ',
    pressEnterToSend: 'መልዕክቱን ለመላክ Enter ይጫኑ',
    appLogo: 'የKingdom Bible Quiz መተግበሪያ አርማ',
    progressChartData: 'የእድገት ሰንጠረዥ መረጃ እዚህ ይታያል',
    share: 'አጋራ',
    inviteFriends: 'ጓደኞችን ይጋብዙ',
    roomCode: 'የክፍል ኮድ',
    shareThisCode: 'ይህን ኮድ ለጓደኞችዎ ያጋሩ ጨዋታዎን እንዲቀላቀሉ',
    shareVia: 'በዚህ ያጋሩ፦',
    inviteAppFriend: 'የመተግበሪያ ጓደኛ ይጋብዙ',
    shareViaMessage: 'በመልዕክት ያጋሩ',
    shareViaEmail: 'በኢሜይል ያጋሩ',
    copied: 'ተቀድቷል!',
    copy: 'ቅዳ',
    earnedOn: 'የተገኘበት ቀን',
    testamentMastery: 'የኪዳን ብቃት',
    bookMastery: 'የመጻሕፍት ብቃት',
    categoryMastery: 'የምድብ ብቃት',
    noMasteryData: 'እስካሁን የብቃት መረጃ የለም።',
    winner: 'አሸናፊ',
    completed: 'ተጠናቋል',
    didNotParticipate: 'አልተሳተፈም',
    leaderboard: 'የደረጃ ሰንጠረዥ',
    correct: 'ትክክል',
    time: 'ጊዜ',
    you: 'እርስዎ',
    creation_origins: 'ፍጥረትና አመጣጥ',
    freedom_law: 'ነጻነትና ሕግ',
    holiness_worship: 'ቅድስናና አምልኮ',
    journey_faith: 'ጉዞና እምነት',
    covenant_law: 'ቃል ኪዳንና ሕግ',
    conquest_victory: 'ድልና ድል መንሳት',
    leadership_cycles: 'አመራርና ዑደቶች',
    love_loyalty: 'ፍቅርና ታማኝነት',
    worship_prayer: 'አምልኮና ጸሎት',
    wisdom_life: 'ጥበብና ሕይወት',
    king_kingdom: 'ንጉሥና መንግሥት',
    servant_action: 'አገልጋይና ተግባር',
    savior_compassion: 'አዳኝና ርኅራኄ',
    son_god_love: 'የእግዚአብሔር ልጅና ፍቅር',
    church_mission: 'ቤተ ክርስቲያንና ተልዕኮ',
    gospel_grace: 'ወንጌልና ጸጋ',
    victory_glory: 'ድልና ክብር',
    accuracy: 'ትክክለኛነት',
    chartPlaceholder: 'የእድገት ሰንጠረዥ መረጃ እዚህ ይታያል',
    currentLanguage: 'አሁን ያለው ቋንቋ',
    progressOverTime: 'በጊዜ ሂደት እድገት',
    score: 'ውጤት',
    tapToChangeLanguage: 'ቋንቋ ለመቀየር ይንኩ',
    // Authentication
    signIn: 'ግባ',
    signUp: 'ተመዝገብ',
    email: 'ኢሜይል',
    password: 'የይለፍ ቃል',
    name: 'ስም',
    preferredLanguage: 'የሚወደው ቋንቋ',
    createAccount: 'መለያ ፍጠር',
    alreadyHaveAccount: 'አካውንት አለዎት?',
    dontHaveAccount: 'አካውንት የለዎትም?',
    welcomeBack: 'እንኳን በደህና መጡ! የመንፈስዎን ጉዞ ለመቀጠል ይግቡ',
    joinKingdom: 'ወደ Kingdom Bible Quiz ይቀላቀሉ! ጉዞዎን ለመጀመር መለያዎን ይፍጠሩ',
    howShouldWeCallYou: 'እንዴት እንጠራዎት?',
    
    // Navigation
    back: 'ተመለስ',
    next: 'ቀጥሎ',
    continue: 'ቀጥል',
    finish: 'ጨርስ',
    cancel: 'ሰርዝ',
    confirm: 'አረጋግጥ',
    close: 'ዝጋ',
    save: 'ማስቀመጥ',    
    // Main Navigation
    solo_play: 'ብቻ ጨዋታ',
    friends_family_play: 'ጓደኞች እና ቤተሰብ',
    play: 'ተጫዎት',
    together: 'አብረን',
    me: 'እኔ',
    live: 'ቀጥታ',
    solo_testament_info: 'በራስዎ ፍጥነት በትኩረት የመጽሐፍ ቅዱስ ትምህርት ይማሩ!',
    multiplayer_testament_info: 'ጓደኞችዎንና ቤተሰብዎን በትኩረት የመጽሐፍ ቅዱስ ጥናት ይፈታተኑ!',
    challenge_testament_info: 'በትኩረት የመጽሐፍ ቅዱስ ርዕሶች የግል ፈተና ይፍጠሩ!',
    community: 'ማህበረሰብ',
    more: 'ተጨማሪ',
    continue_journey: 'ጉዞዎን ይቀጥሉ',
    explore: 'ያስሱ',

    // Testament Screen
    header: 'የመጽሐፍ ቅዱስ የት ክፍል?',
    old: 'ብሉይ ኪዳን',
    old_desc: 'ከዘፍጥረት እስከ ማልአኪ መጻሕፍት',
    new: 'አዲስ ኪዳን',
    new_desc: 'ከማቴዎስ እስከ ራእይ መጻሕፍት',
    books_of_the_bible: 'የመጽሐፍ ቅዱስ መጻሕፍት',
    books_of_the_bible_desc: 'ከዘፍጥረት እስከ ራእይ ያሉ ሁሉም መጻሕፍት',
    general: 'አጠቃላይ',
    general_description: 'ስለ የተለያዩ መጽሐፍ ቅዱሳዊ ጉዳዮች ጥያቄዎች',
    books_focus_description: 'የተወሰኑ የመጽሐፍ ቅዱስ መጻሕፍትን አጥን',
    begin_journey: 'ጉዞዎን ይጀምሩ',
    choose_your_path: 'መንገዶን ይምረጡ',
    explore_gods_word: 'የእግዚአብሔርን ቃል ይዳስሱ',
    daily_challenge_label: 'የዕለቱ ፈተና',
    start_todays_challenge: 'የዛሬውን ፈተና ጀምር',
    resume_last_topic: 'የመጨረሻውን ርዕስ ቀጥል',
    local_progress_title: 'የመሣሪያ ላይ እድገት',
    local_progress_subtitle: 'እስክትገቡ ድረስ ይህ እድገት በዚህ መሣሪያ ላይ ይቆያል።',
    quizzes_completed_label: 'የተጠናቀቁ ጥያቄዎች',
    recovery_welcome_back: 'እንኳን ደህና መጡ',
    recovery_saved_progress_found: 'ካለፈው ጊዜ የተቀመጠ እድገትዎን አግኝተናል።',
    recovery_sign_in_restore: 'እድገትዎን ለመመለስ በ{{provider}} ይግቡ።',
    recovery_sign_in_restore_cta: 'በ{{provider}} ግባ',
    recovery_skip_restore: 'ሳይመልሱ መጫወት ቀጥል',
    old_testament: 'ብሉይ ኪዳን',
    new_testament: 'አዲስ ኪዳን',
    hebrew_scriptures: 'የዕብራይስጥ መጻሕፍት እና የትንቢት መጻሕፍት',
    christian_scriptures: 'የወንጌል እና የሐዋርያት መልእክቶች',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: 'ስለ ምን መጠየቅ ትፈልጋለህ?',
    category: 'ምድብ',
    no_difficulties: 'ምንም ደረጃዎች አልተገኙም።',
    select_your_challenge: 'ፈተናዎን ይምረጡ',
    choose_difficulty_description: 'ከመጽሐፍ ቅዱሳዊ እውቀትዎ ጋር በተሻለ ሁኔታ የሚጣጣመውን የችግር ደረጃ ይምረጡ',
    easy: 'ቀላል',
    easy_desc: 'ለጀማሪዎች ይመች',
    medium: 'መካከለኛ',
    medium_desc: 'ለመደበኛ ተጫዋቾች',
    hard: 'ከባድ',
    hard_desc: 'እውነተኛ ፈተና!',
    
    // Game Modes
    solo: 'ብቸኛ ጨዋታ',
    multiplayer: 'ብዙ ተጫዋች',
    
    // Common UI Elements
    loading: 'እየጫነ...',
    loadingApp: 'Kingdom Bible Quiz እየጫነ...',
    error: 'ስህተት',
    success: 'ስኬት',
    warning: 'ማስጠንቀቂያ',
    info: 'መረጃ',
    player: 'ተጫዋች',
    user: 'ተጠቃሚ',
    
    // Accessibility Labels
    backButton: 'ተመለስ',
    closeButton: 'ዝጋ',
    userAvatar: 'የተጠቃሚ አምሳል',
    playerLabel: 'ተጫዋች',
    
    // Accessibility
    select_book_hint: 'ይህን የመጽሐፍ ቅዱስ መጽሐፍ ለመምረጥ ይንኩ',
    no_testament_error: 'ምንም ኪዳን አልተመረጠም። እባክዎን ተመለሱ እና ብሉይ ወይም አዲስ ኪዳንን ይምረጡ።',
    
    // Book Selection Screen
    old_testament_display: 'ብሉይ ኪዳን',
    new_testament_display: 'አዲስ ኪዳን', 
    popular: 'ተወዳጅ',
    chapters: 'ምዕራፎች',
    scripture_study: 'የመጽሐፍ ቅዱስ ጥናት',
    
    // Quiz UI
    loading_quiz: 'ጥያቄዎች እየተጫኑ...',
    quiz_complete: 'ጥያቄዎች አብቅተዋል!',
    well_done: 'በጣም ጥሩ!',
    question_progress: 'ጥያቄ {current} ከ {total}',
    seconds: 'ሰ',
    time_remaining: 'የተቀረ ጊዜ',
    explanation: 'ማብራሪያ',
    next_question: 'ቀጣይ ጥያቄ',
  },
  
  ko: {
    retry: '다시 시도',
    ok: '확인',
    none: '없음',
    previous: '이전',
    top: '상위',
    noQuestionsAvailable: '이 선택에는 사용할 수 있는 문제가 없습니다.',
    common: {
      retry: '다시 시도',
    },
    inviteFriendPrompt: '친구 초대',
    enterFriendId: '친구의 사용자 ID를 입력하세요:',
    send: '보내기',
    inviteSuccess: '성공',
    inviteSuccessMessage: '친구에게 게임 초대를 보냈습니다!',
    inviteError: '오류',
    inviteErrorMessage: '초대 알림을 보내지 못했습니다.',
    messageInputField: '메시지 입력란',
    pressEnterToSend: 'Enter 키를 눌러 메시지를 보내세요',
    appLogo: 'Kingdom Bible Quiz 앱 로고',
    progressChartData: '여기에 진행 상황 차트 데이터가 표시됩니다',
    share: '공유',
    inviteFriends: '친구 초대',
    roomCode: '방 코드',
    shareThisCode: '친구들에게 이 코드를 공유해 게임에 참여시키세요',
    shareVia: '공유 방법:',
    inviteAppFriend: '앱 친구 초대',
    shareViaMessage: '메시지로 공유',
    shareViaEmail: '이메일로 공유',
    copied: '복사됨!',
    copy: '복사',
    earnedOn: '획득일',
    testamentMastery: '성경 구약·신약 숙련도',
    bookMastery: '성경 책 숙련도',
    categoryMastery: '카테고리 숙련도',
    noMasteryData: '아직 숙련도 데이터가 없습니다.',
    winner: '우승자',
    completed: '완료',
    didNotParticipate: '참여하지 않음',
    leaderboard: '순위표',
    correct: '정답',
    time: '시간',
    you: '나',
    creation_origins: '창조와 기원',
    freedom_law: '자유와 율법',
    holiness_worship: '거룩함과 예배',
    journey_faith: '여정과 믿음',
    covenant_law: '언약과 율법',
    conquest_victory: '정복과 승리',
    leadership_cycles: '리더십과 순환',
    love_loyalty: '사랑과 충성',
    worship_prayer: '예배와 기도',
    wisdom_life: '지혜와 삶',
    king_kingdom: '왕과 나라',
    servant_action: '종과 행동',
    savior_compassion: '구원자와 긍휼',
    son_god_love: '하나님의 아들과 사랑',
    church_mission: '교회와 선교',
    gospel_grace: '복음과 은혜',
    victory_glory: '승리와 영광',
    accuracy: '정확도',
    chartPlaceholder: '여기에 진행 상황 차트 데이터가 표시됩니다',
    currentLanguage: '현재 언어',
    progressOverTime: '시간에 따른 진행 상황',
    score: '점수',
    tapToChangeLanguage: '탭하여 언어 변경',
    // Authentication
    signIn: '로그인',
    signUp: '회원가입',
    email: '이메일',
    password: '비밀번호',
    name: '이름',
    preferredLanguage: '선호 언어',
    createAccount: '계정 만들기',
    alreadyHaveAccount: '이미 계정이 있으신가요?',
    dontHaveAccount: '계정이 없으신가요?',
    welcomeBack: '다시 오신 것을 환영합니다! 영적 여정을 계속하려면 로그인하세요',
    joinKingdom: 'Kingdom Bible Quiz에 참여하세요! 여정을 시작하려면 계정을 만드세요',
    howShouldWeCallYou: '어떻게 불러드릴까요?',
    
    // Navigation
    back: '뒤로',
    next: '다음',
    continue: '계속',
    finish: '완료',
    cancel: '취소',
    confirm: '확인',
    close: '닫기',
    save: '저장',    
    // Main Navigation
    solo_play: '혼자 플레이',
    friends_family_play: '친구와 가족',
    play: '플레이',
    together: '함께',
    me: '나',
    live: '라이브',
    solo_testament_info: '자신의 속도로 집중 성경 학습을 하세요!',
    multiplayer_testament_info: '친구와 가족에게 집중 성경 학습으로 도전하세요!',
    challenge_testament_info: '집중 성경 주제로 개인 도전을 만드세요!',
    community: '커뮤니티',
    more: '더보기',
    continue_journey: '여정을 계속하세요',
    explore: '탐색',

    // Testament Screen
    header: '성경의 어느 부분?',
    old: '구약',
    old_desc: '창세기부터 말라기까지의 책들',
    new: '신약',
    new_desc: '마태복음부터 요한계시록까지의 책들',
    books_of_the_bible: '성경의 책들',
    books_of_the_bible_desc: '창세기부터 요한계시록까지의 모든 책들',
    general: '일반',
    general_description: '다양한 성경 주제와 내용에 대한 퀴즈',
    books_focus_description: '성경의 특정 책들을 공부하세요',
    begin_journey: '여행을 시작하세요',
    choose_your_path: '길을 선택하세요',
    explore_gods_word: '하나님의 말씀을 탐구하세요',
    daily_challenge_label: '오늘의 도전',
    start_todays_challenge: '오늘의 도전 시작하기',
    resume_last_topic: '마지막 주제 이어하기',
    local_progress_title: '기기 내 진행 상황',
    local_progress_subtitle: '로그인할 때까지 이 진행 상황은 이 기기에만 저장됩니다.',
    quizzes_completed_label: '완료한 퀴즈',
    recovery_welcome_back: '다시 오신 것을 환영합니다',
    recovery_saved_progress_found: '이전 세션에서 저장된 진행 상황을 찾았습니다.',
    recovery_sign_in_restore: '{{provider}}(으)로 로그인하여 진행 상황을 복원하세요.',
    recovery_sign_in_restore_cta: '{{provider}}(으)로 로그인',
    recovery_skip_restore: '복원하지 않고 계속하기',
    old_testament: '구약',
    new_testament: '신약',
    hebrew_scriptures: '히브리 성경과 예언서',
    christian_scriptures: '복음서와 사도서신',
    
    // Difficulty Screen
    what_would_you_like_to_be_quizzed_on: '무엇에 대해 퀴즈를 보시겠습니까?',
    category: '카테고리',
    no_difficulties: '난이도를 찾을 수 없습니다.',
    select_your_challenge: '도전을 선택하세요',
    choose_difficulty_description: '성경 지식에 가장 적합한 난이도 수준을 선택하세요',
    easy: '쉬움',
    easy_desc: '초보자에게 적합',
    medium: '보통',
    medium_desc: '일반 플레이어용',
    hard: '어려움',
    hard_desc: '진정한 도전!',
    
    // Game Modes
    solo: '혼자 플레이',
    multiplayer: '멀티플레이어',
    
    // Common UI Elements
    loading: '로딩 중...',
    loadingApp: 'Kingdom Bible Quiz 로딩 중...',
    error: '오류',
    success: '성공',
    warning: '경고',
    info: '정보',
    player: '플레이어',
    user: '사용자',
    
    // Accessibility Labels
    backButton: '뒤로',
    closeButton: '닫기',
    userAvatar: '사용자 아바타',
    playerLabel: '플레이어',
    
    // Accessibility
    select_book_hint: '이 성경책을 선택하려면 탭하세요',
    no_testament_error: '선택된 성경이 없습니다. 돌아가서 구약 또는 신약을 선택해 주세요.',
    
    // Book Selection Screen
    old_testament_display: '구약성경',
    new_testament_display: '신약성경', 
    popular: '인기',
    chapters: '장',
    scripture_study: '성경 공부',
    
    // Quiz UI
    loading_quiz: '퀴즈 로딩 중...',
    quiz_complete: '퀴즈 완료!',
    well_done: '잘했습니다!',
    question_progress: '문제 {current}/{total}',
    seconds: '초',
    time_remaining: '남은 시간',
    explanation: '설명',
    next_question: '다음 문제',
  }
};
